export default {
  button: {
    submit: 'Confirm',
    cancel: 'Cancel',
    reset: 'Reset',
    previous: 'Previous',
    next: 'Next',
    lastStep: 'Previous',
  },
  title: 'Image Cropping',
  videoTitle: 'Crop Video',
  cropTimer: 'Interception Time',
  imageZoom: 'Image Zoom',
  imageSize: 'Image Size',
  xlzTitle: 'Sequence Cropping',
  closeTip: 'Closing is not allowed during the upload process.',
  submit: 'Finish',
}
